// extracted by mini-css-extract-plugin
export default {"tabItems":"TabNavBar_tabItems__Sy4KX","tabItem":"TabNavBar_tabItem__+aNHF"};